import React from 'react';
import styled from 'styled-components';

type Props = {
  width?: string,
  style?: any,
  children?: React.ReactNode,
};

const Container = ({children, ...props}: Props) => (
  <StyledContainer {...props}>{children}</StyledContainer>
);

export default Container;

const StyledContainer = styled.div`
  margin: auto;
  text-align: center;
  padding: ${props => !props.width && '0 100px'};
  width: ${props => props.width && props.width};
  padding-bottom: 100px;

  .table th {
    border-top: none;
  }
`;
